import PaymentTerminals from './PaymentTerminals';

export default PaymentTerminals;
